import { Component, OnInit } from '@angular/core';
import { ProductAuthResponse } from 'src/app/models/productAuth';

@Component({
  selector: 'app-issue-no-product-authentication',
  templateUrl: './issue-no-product-authentication.component.html',
  styleUrls: ['./issue-no-product-authentication.component.css']
})
export class IssueNoProductAuthenticationComponent implements OnInit {
  isModalShown:boolean
  prodDetails: ProductAuthResponse = new ProductAuthResponse();
  constructor() { }

  ngOnInit() {
    
    this.isModalShown=true
    this.prodDetails = JSON.parse(localStorage.getItem('IssueData'));
  }

  onHidden(){
    
    this.isModalShown=false
  }

}
